var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.signature)?_c('div',{staticClass:"form-submission-card-signature",on:{"click":function($event){return _vm.$emit('open-signature')}}},[_c('img',{attrs:{"src":'/svg/' + _vm.resource_group + '/signature.svg',"alt":`${_vm.signature.user ? _vm.signature.user.full_name + '\'s signature' : 'signature'}`,"width":"35px","height":"auto"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }